import React from 'react';
import Logo from './Logo';
import DropDownUser from './DropDownUser';
import DropDownDBSrc from './DropDownDBSrc';
import '../../assets/Header.css'

function Header ({tab, onTabClick}) {
  const rulesBlue = tab === 'rules' ? 'headerBlue borderBlue' : '';
  const matrixBlue = tab === 'matrix' ? 'headerBlue borderBlue' : '';
  const cacheBlue = tab === 'cache' ? 'headerBlue borderBlue' : '';

  return (
    <header className="flex items-center justify-between px-6 bg-white sticky top-0 z-10 border-b-[1px] border-gray border-solid pt-1">
      <div className="flex items-center gap-4 flex-nowrap">
        <Logo />
        <button href='' className={`font-bold text-lg tracking-wide px-2 text-left buttonHeight ${rulesBlue}`} onClick={() => onTabClick('rules')}>Rules Viewer</button>
        <button href='' className={`font-bold text-lg tracking-wide px-2 text-left buttonHeight ${matrixBlue}`} onClick={() => onTabClick('matrix')}>Matrix Viewer</button>
        <button href='' className={`font-bold text-lg tracking-wide px-2 text-left buttonHeight ${cacheBlue}`} onClick={() => onTabClick('cache')}>Cache Viewer</button>
      </div>
        <DropDownDBSrc />
        <DropDownUser />
    </header>
  )
}

export default Header;